import { enGB as dateFnsLocaleEnGb } from 'date-fns/locale';
import { capitalize } from 'lodash';

export const attrsForNumKeyboard = {
  inputmode: 'numeric',
  pattern: '[0-9]*',
  type: 'number',
};

export const licencePrefillNameRegex = /^[A-Za-z-\s]+$/;
export const regNumberRegex = /^[A-Za-z0-9\s]{0,10}$/;

export const createOptions = ({ source, valueKey = 'value', textKey = 'text', asNumbers }) => {
  if (Array.isArray(source)) {
    return source.map(item => ({
      [valueKey]: asNumbers ? +item : item,
      [textKey]: item,
    }));
  }
  return Object.keys(source).map(key => ({
    [valueKey]: asNumbers ? +key : key,
    [textKey]: source[key],
  }));
};

export const moveCursorToEnd = el => {
  if (typeof el.selectionStart === 'number') {
    el.selectionStart = el.selectionEnd = el.value.length;
  } else if (typeof el.createTextRange !== 'undefined') {
    el.focus();
    var range = el.createTextRange();
    range.collapse(false);
    range.select();
  }
};

export const monthsOptions = [...Array(12)].map((_, i) => ({
  value: i + 1,
  text: dateFnsLocaleEnGb.localize.month(i),
}));

export const limitValueChars = (value, maxChars = 3) => {
  return () => {
    if (!value) return value;
    return value.length > maxChars ? value.substring(0, maxChars) : value;
  };
};

export const limitInputChars = function (step, value, limit) {
  step[value] = (limitValueChars(step[value], limit))();
};

export const getPlaceholderResponsiveText = (text, isMobile) => {
  if (!isMobile) return text;
  if (text.indexOf('Please ') !== 0) return text;
  return capitalize(text.replace('Please ', ''));
};

export const deepRemoveKeys = (obj, keys = [], testKey = () => false) => {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      if ((Array.isArray(keys) && keys.includes(prop)) || testKey(prop)) {
        delete obj[prop];
      } else if (typeof (obj[prop]) === 'object') {
        deepRemoveKeys(obj[prop], keys, testKey);
      }
    }
  }
};

/**
 * Returns a string with a UK locale representation of this number
 * @param {Number} number
 * @param {String} locale='en-gb'
 * @returns {String} formatted string in the UK locale
 */
export const getNumberFormatted = (number, locale = 'en-gb') => {
  return number.toLocaleString(locale);
};
